// Kontakty: seznam a záznam jsou deklarované v PHP; zde jen okno importu vCard.
import { simpleBar } from '@core/components/chrome';
import { registerComponent } from '@core/views/factory';
import { action, ApiError } from '@core/api';
import { h } from '@core/dom';
import { t, tk } from '@core/i18n';
import { icon } from '@core/icons';
import { pickFile } from '@core/shell/picker';
import { toast } from '@core/components/toast';
import { events } from '@core/events';
import type { StorageItem } from '@core/contract';

registerComponent('kontakty-import', ({ desc, win, wm }) => {
  const p = desc.payload as { books: { value: string; label: string }[]; defaultBook: string | null; file: { id: string; name: string } | null };
  let file: { id: string; name: string } | null = p.file;
  const bookSel = h('select', { class: 'input' }, p.books.map((b) => h('option', { value: b.value, selected: b.value === p.defaultBook }, b.label)));
  const fileName = h('span', { class: 'import-file' }, file ? file.name : '—');
  const pick = h('button', { type: 'button', class: 'btn' }, icon('upload'), t('kontakty.import.pick'));
  const run = h('button', { type: 'button', class: 'btn primary' }, t('kontakty.import.run'));
  const result = h('div', { class: 'import-result' });
  pick.addEventListener('click', async () => {
    const picked = await pickFile({ mode: 'upload', multiple: false, title: t('kontakty.import.pick'), parent: win });
    const item: StorageItem | undefined = picked?.[0];
    if (item) {
      file = { id: item.id, name: item.name };
      fileName.textContent = item.name;
    }
  });
  run.addEventListener('click', async () => {
    if (!file) {
      toast(t('kontakty.import.no_file'), 'warn');
      return;
    }
    run.disabled = true;
    run.textContent = t('kontakty.import.running');
    try {
      const r = await action<{ created: number; updated: number; skipped: number }>(desc.app, desc.window, 'run', desc.params as Record<string, unknown>, { fileId: file.id, book: bookSel.value });
      result.replaceChildren(
        h('p', null, icon('check', 'icon cell-check'), ' ', t('kontakty.import.done', r)),
        h('button', { type: 'button', class: 'btn', onClick: () => void wm.open({ app: 'kontakty', window: 'seznam' }) }, t('kontakty.import.open_list')),
      );
      events.kick();
    } catch (e) {
      toast(tk((e as ApiError).message, (e as ApiError).params ?? undefined), 'error');
    } finally {
      run.disabled = false;
      run.textContent = t('kontakty.import.run');
    }
  });
  const el = h(
    'div',
    { class: 'view kontakty-import' },
    h('p', { class: 'muted small' }, t('kontakty.import.hint')),
    h('label', { class: 'field' }, h('span', { class: 'field-label' }, t('kontakty.import.book')), bookSel),
    h('div', { class: 'field' }, h('span', { class: 'field-label' }, t('kontakty.import.file')), h('div', { class: 'row' }, pick, fileName)),
    h('div', { class: 'row import-run' }, run),
    result,
  );
  // nový vzhled: Importovat v liště záhlaví (stav tlačítka podle běhu)
  const sb = simpleBar(win, wm, () => [{ id: 'run', label: run.textContent ?? t('kontakty.import.run'), icon: 'import', place: 'primary', disabled: run.disabled, onClick: () => run.click() }]);
  if (sb.active) { el.querySelector('.import-run')?.setAttribute('hidden', ''); new MutationObserver(() => sb.refresh()).observe(run, { attributes: true, childList: true, characterData: true, subtree: true }); }
  return { el, setMode: () => sb.refresh() };
});
